import { FC } from 'react';

import { Input } from '../../../components/ui/Input';
import { Label } from '../../../components/ui/Label';

interface Props {
    id: string;
    label: string;
    value: string;
    onChange: (value: string) => void;
    error?: string;
    placeholder?: string;
    required?: boolean;
}

export const DeliveryProfileField: FC<Props> = ({
    id,
    label,
    value,
    onChange,
    error,
    placeholder,
    required = false,
}) => {
    return (
        <div className="space-y-1">
            <Label htmlFor={id}>
                {label}
                {required && ' *'}
            </Label>
            <Input
                id={id}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                className={error ? 'border-red-500' : ''}
            />
            {error && <p className="text-xs text-red-500">{error}</p>}
        </div>
    );
};
